<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.blue">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-2">
      <mat-icon class="medium-icon m-6">description</mat-icon>
      <span class="f-s-20">{{editingExamQuestions? "Edit" : "View"}} Exam Questions</span>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col gap-4">
  <div class="flex flex-row justify-start items-center gap-4">
    <span class="f-s-20">Exam Questions</span>
    <button *ngIf="editingExamQuestions" type="button" mat-icon-button color="warn"
      matTooltip="Stop Editing Exam Questions" matTooltipShowDelay=800
      aria-label="Stop Editing Exam Questions" (click)="toggleQuizEdit()">
      <mat-icon>edit_off</mat-icon>
    </button>
    <button *ngIf="!editingExamQuestions" type="button" mat-icon-button color="primary"
      matTooltip="Edit Exam Questions" matTooltipShowDelay=800 aria-label="Edit Exam Questions"
      (click)="toggleQuizEdit()">
      <mat-icon>edit</mat-icon>
    </button>
    <button  *ngIf="editingExamQuestions" type="button"
      mat-button color="primary"
      matTooltip="toggleArchived" matTooltipShowDelay=800
      aria-label="Toggle Archived" (click)="toggleArchived()">
      {{showArchived? "Hide Archived" : "Show Archived"}}
    </button>
    <button *ngIf="editingExamQuestions" type="button" mat-stroked-button color="primary"
      matTooltip="Update Quiz Map" matTooltipShowDelay=800
      aria-label="Update Quiz Map" (click)="saveQuiz()">
      Save Quiz
    </button>
  </div>
  <span *ngIf="!editingExamQuestions" class="f-s-14">Drag and Drop to Change question Ordering</span>

  <!--
    Viewing
  -->
  <div style="cursor: pointer" *ngIf="!editingExamQuestions" cdkDropList (cdkDropListDropped)="dropQuestion($event)" class="flex flex-col">
    <div *ngFor="let element of examMap; let elementIndex = index" cdkDrag class="flex flex-col gap-3">
      <!--Core Elements-->
      <div *ngIf="!element.archived" class="max-md:flex-col flex flex-row justify-start items-center gap-3">
        <span><strong>({{getIndexNumber(elementIndex)}})</strong></span>
        <span>{{element.text}}</span>
      </div>
      <!--Sub Sections-->
      <div *ngIf="!element.archived" class="flex flex-row">
        <span class="w-[5%]"></span>
        <div cdkDropList (cdkDropListDropped)="dropAnswer($event, element.examAnswers)" class="flex flex-col gap-2 w-[70%]">
          <div *ngFor="let answer of element.examAnswers; let answerIndex = index" cdkDrag class="flex flex-col gap-2">
            <div *ngIf="!answer.archived" class="max-md:flex-col flex flex-row gap-4">
              <span><strong>({{getAnswerIndexLetter(elementIndex, answerIndex, answer.archived)}}) </strong></span>
              <span [ngStyle]="answer.correct === true ? {'color':'green','font-weight':'bolder'} : {}" >{{answer.text}}</span>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--
    Editing
  -->
  <div *ngIf="editingExamQuestions" class="flex flex-col">
    <div *ngFor="let element of examMap; let elementIndex = index" class="flex flex-col gap-2">
      <!--Core Elements-->
      <div *ngIf="!element.archived || showArchived" [ngClass]="{'archive-element': element.archived}" class="max-md:flex-col flex flex-row justify-start items-center gap-2">
        <span><strong>({{getIndexNumber(elementIndex)}})</strong></span>
        <mat-form-field class="w-[70%]">
          <textarea required rows="1" matInput type="text" [(ngModel)]="element.text" name="elementText" placeholder="Text"></textarea>
        </mat-form-field>
        <div class="flex flex-row gap-2 w-[20%]">
          <button *ngIf="editingExamQuestions" type="button" mat-icon-button color="warn" matTooltip="Delete Question"
            matTooltipShowDelay=800 aria-label="Delete Question" (click)="deleteQuiz(element)">
            <mat-icon>delete</mat-icon>
          </button>
          <button *ngIf="editingExamQuestions && !element.archived" type="button" mat-icon-button color="warn" matTooltip="Archive Question"
            matTooltipShowDelay=800 aria-label="Archive Question" (click)="toggleArchiveQuestion(element)">
            <mat-icon>archive</mat-icon>
          </button>
          <button *ngIf="editingExamQuestions && element.archived" type="button" mat-icon-button color="warn" matTooltip="Unarchive Question"
            matTooltipShowDelay=800 aria-label="Unrchive Question" (click)="toggleArchiveQuestion(element)">
            <mat-icon>unarchive</mat-icon>
          </button>
          <button *ngIf="!element.addingAnswer && !element.archived" type="button" mat-icon-button color="primary"
            matTooltip="Add Answer" matTooltipShowDelay=800 aria-label="Add Answer"
            (click)="toggleAnswerAddForm(element, true)">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <!--Answers-->
      <div [ngClass]="{'archive-element': element.archived}" *ngIf="!element.archived  || showArchived" class="flex flex-row w-[100%]">
        <span class="w-[5%]"></span>
        <div class="flex flex-col gap-2 w-[70%]">

          <div *ngIf="element.addingAnswer" class="max-md:flex-col flex flex-row justify-start items-center gap-2">
            <span><strong>({{getAnswerIndexLetter(elementIndex, element.examAnswers.length, element.archived)}})</strong></span>
            <mat-form-field class="w-[100%]">
              <textarea rows="1" matInput type="text" [(ngModel)]="subText" name="subText" placeholder="Text"></textarea>
            </mat-form-field>

            <div class="flex flex-row gap-2">
              <button *ngIf="subText != ''" type="button" mat-stroked-button color="primary" matTooltip="Submit Answer" matTooltipShowDelay=800
                aria-label="Submit Answer" (click)="addAnswer(element)">
                save
              </button>
              <button type="button" mat-stroked-button color="warn" matTooltip="Cancel Answer Submission"
                matTooltipShowDelay=800 aria-label="Cancel Answer Submission"
                (click)="toggleAnswerAddForm(element, false)">
                cancel
              </button>
            </div>
          </div>
          <mat-radio-group>

          <div *ngFor="let answer of element.examAnswers; let answerIndex = index" class="flex flex-col gap-2">
            <div [ngClass]="{'archive-element': element.archived || answer.archived}" *ngIf="!answer.archived || showArchived" class="max-md:flex-col flex flex-row justify-start items-center gap-2">
              <span><strong>({{getAnswerIndexLetter(elementIndex, answerIndex, answer.archived || element.archived)}}) </strong></span>
              <mat-form-field class="w-[100%]">
                <textarea rows="1" matInput type="text" [(ngModel)]="answer.text" name="answerText" placeholder="Text"></textarea>
              </mat-form-field>
              <mat-radio-button [(ngModel)]="answer.correct" [checked]="answer.correct" (click)="setCorrect(element, answer)" [value]="answer.correct" [name]="answer.text" >Correct Answer</mat-radio-button>
              <div class="flex flex-row gap-2">
                <button *ngIf="editingExamQuestions" type="button" mat-icon-button color="warn" matTooltip="Delete Answer"
                  matTooltipShowDelay=800 aria-label="Delete Answer" (click)="deleteAnswer(element, answer)">
                  <mat-icon>delete</mat-icon>
                </button>

                <button *ngIf="editingExamQuestions && !answer.archived && !element.archived" type="button" mat-icon-button color="warn" matTooltip="Archive Section"
                  matTooltipShowDelay=800 aria-label="Archive Question" (click)="toggleArchiveAnswer(answer)">
                  <mat-icon>archive</mat-icon>
                </button>
                <button *ngIf="editingExamQuestions && answer.archived && !element.archived" type="button" mat-icon-button color="warn" matTooltip="Unarchive Section"
                  matTooltipShowDelay=800 aria-label="Unarchive Section" (click)="toggleArchiveAnswer(answer)">
                  <mat-icon>unarchive</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-radio-group>
        </div>
      </div>
    </div>
    <button *ngIf="!addingCoreElement" type="button" mat-stroked-button color="primary" matTooltip="Add Question"
      matTooltipShowDelay=800 aria-label="Add Question" (click)="toggleQuestionAddForm()" class="w-[10%]">
      Add New Question
    </button>

    <div *ngIf="addingCoreElement" class="max-md:flex-col flex flex-row justify-start items-center gap-2">
      <span><strong>({{examMap.length + 1}})</strong></span>
      <mat-form-field class="w-[70%]">
        <textarea rows="1" matInput type="text" [(ngModel)]="coreText" name="coreText" placeholder="Text"></textarea>
      </mat-form-field>
      <div class="flex flex-row gap-2 w-[20%]">
        <div>
          <button *ngIf="coreText != ''" type="button" mat-stroked-button color="primary" matTooltip="Submit Question" matTooltipShowDelay=800
            aria-label="Submit Question" (click)="addCoreElement()">
            save
          </button>
        </div>
        <div>
          <button type="button" mat-stroked-button color="warn" matTooltip="Camcel" matTooltipShowDelay=800
            aria-label="Cancel" (click)="toggleQuestionAddForm()">
            cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col">
    <div>
    <button *ngIf="editingExamQuestions" type="button" mat-stroked-button color="primary" matTooltip="Update Quiz Map"
      matTooltipShowDelay=800 aria-label="Update Quiz Map" (click)="saveQuiz()">
      Save Quiz
    </button>
  </div>
    <span *ngIf="!examValid" class="text-red-400">
      <strong>All Questions Must Have At Least Two Answers And One Correct Answer</strong>
    </span>
  </div>
</div>
